export default "__VITE_ASSET__6V33n3u$__"